export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";